 import React from "react";
import { Link } from "react-router-dom";
import {
  FaBullhorn,
  FaCalendarAlt,
  FaHandsHelping
} from "react-icons/fa";
import "./WhyEcoVibe.css";

const WhyEcoVibe = () => {
  return (
    <section className="eco-impact-section">

<div className="why-ecovibe two-column">

  <div className="why-left">
    <h2>Why EcoVibe?</h2>
    <p>
      EcoVibe is a digital platform designed to bring people together
      for environmental protection. It allows citizens to report
      environmental issues, participate in awareness campaigns,
      and take part in eco-friendly events that create real impact.
    </p>

    <p>
      By connecting communities, volunteers, and organizers,
      EcoVibe turns small actions into meaningful change
      for a cleaner and greener future.
    </p>
  </div>

  <div className="why-right">

    <div className="why-item">
      <FaBullhorn className="icon orange" />
      <div>
        <h4>Awareness Campaigns</h4>
        <p>
          Organize and participate in campaigns that educate people
          about environmental protection and sustainability.
        </p>
      </div>
    </div>

    <div className="why-item">
      <FaCalendarAlt className="icon blue" />
      <div>
        <h4>Eco-Friendly Events</h4>
        <p>
          Join clean-up drives, tree plantation events, and
          community-based environmental activities.
        </p>
      </div>
    </div>

    <div className="why-item">
      <FaHandsHelping className="icon green" />
      <div>
        <h4>Volunteer & Community Support</h4>
        <p>
          Connect with volunteers and work together to solve
          environmental problems effectively.
        </p>
      </div>
    </div>

  </div>
</div>

      <div className="impact-counter">
        <div className="counter-box green">
          <h3>50+</h3>
          <p>Issues Reported</p>
        </div>

        <div className="counter-box orange">
          <h3>10+</h3>
          <p>Awareness Campaigns</p>
        </div>

        <div className="counter-box blue">
          <h3>10+</h3>
          <p>Eco Events Activites Organized</p>
        </div>

        <div className="counter-box darkgreen">
          <h3>20+</h3>
          <p>Active Volunteers</p>
        </div>
      </div>

      <div className="cta-box">
        <h2>Be Part of the Change 🌍</h2>
        <p>
          Join EcoVibe today and take part in awareness campaigns,
          eco events, and volunteer activities to build a greener future.
        </p>

        <div className="cta-buttons">
          <Link to="/join-as-volunteer">
            <button className="cta-primary">Join as Volunteer</button>
          </Link>

          <Link to="/event">
            <button className="cta-secondary">Join an Event</button>
          </Link>
        </div>
      </div>

    </section>
  );
};

export default WhyEcoVibe;